import {FC, useCallback, useState} from 'react';
import {TransformComponent, TransformWrapper} from 'react-zoom-pan-pinch';
import Arrows from '../arrows/Arrows';
import TaskRow from '../task_row/TaskRow';
import TaskGridControls from './Controls';
import {ZoomGridOptions} from '../../../../constants/tasks';

const TaskGrid: FC = () => {
  const [isTransformDisabled, setIsTransformDisabled] = useState(false);

  const disableTransform = useCallback(() => {
    setIsTransformDisabled(true);
  }, []);

  const enableTransform = useCallback(() => {
    setIsTransformDisabled(false);
  }, []);

  return (
    <div className="tasks-grid">
      <TransformWrapper
        disabled={isTransformDisabled}
        initialScale={ZoomGridOptions.INITIAL_SCALE}
        minScale={ZoomGridOptions.MIN_SCALE}
        maxScale={ZoomGridOptions.MAX_SCALE}
        limitToBounds
        centerOnInit
      >
        {({zoomIn, zoomOut, zoomToElement, state: {scale}}) => (
          <>
            <TransformComponent>
              <div className="tasks-grid_wrapper">
                <div className="task-row">
                  <TaskRow
                    zoomToElement={zoomToElement}
                    enableTransform={enableTransform}
                    disableTransform={disableTransform}
                  />
                </div>
              </div>
            </TransformComponent>

            <Arrows scale={scale} />

            <TaskGridControls
              zoomIn={zoomIn}
              zoomOut={zoomOut}
              zoomToElement={zoomToElement}
            />
          </>
        )}
      </TransformWrapper>
    </div>
  );
};

export default TaskGrid;
